import { useEffect, useState } from "react";
import { usePayment } from "src/hooks/context";
import { useTransferSubscription } from "src/hooks/useTransferSubscription";
import MerchantFallback from "../../assets/merchantFallback.png";
import YourPayments from "../YourPayments/YourPayments";

export const PaymentSummary = () => {
    const { paymentState } = usePayment();

    console.log("[PaymentSummary]", paymentState.transferId);

    if (
        !paymentState.transferId ||
        !paymentState.recipient?.name ||
        !paymentState.amount
    ) {
        return <YourPayments
            name={
                "Loading..."
            }
            icon={MerchantFallback}
            description={"✌️"}
            amount={`0`}
            isPaymentProcessing={true}
            isLoading={true}
            logTitle="⏳ Loading your payment"
        />
    }

    return <PaymentSummaryWithTransferSubscription
        transferId={paymentState.transferId}
        payment={{ name: paymentState.recipient.name, status: paymentState.status || undefined, description: paymentState.note || undefined, logo: paymentState.recipient?.logo, amount: paymentState.amount }} />
};

type PaymentSummaryWithTransferSubscriptionProps = {
    transferId: string;
    payment: {
        name: string;
        description?: string;
        logo?: string;
        amount: string;
        status?: string;
    }
}

const PaymentSummaryWithTransferSubscription = ({ transferId, payment }: PaymentSummaryWithTransferSubscriptionProps) => {
    const [paymentStatus, setPaymentStatus] = useState(payment.status);
    const [logTitle, setLogTitle] = useState(payment.status === "PAID" ? "✅ You've paid" : payment.status === "ERROR" ? "❌ Payment unsuccessful" : "⏳ Payment in progress");
    const { status } = useTransferSubscription(transferId);

    useEffect(() => {
        if (status === null) {
            return
        }
        setPaymentStatus(status);
    }, [status]);

    useEffect(() => {
        if (paymentStatus === "PAID") {
            setLogTitle("✅ You've paid");
        }
        if (paymentStatus === "ERROR") {
            setLogTitle("❌ Payment unsuccessful");
        }
        if (paymentStatus === "PENDING") {
            setLogTitle("⏳ Payment in progress");
        }
    }, [paymentStatus, setLogTitle]);

    return <YourPayments
        name={
            payment?.name || "..."
        }
        icon={payment?.logo || MerchantFallback}
        description={payment?.description || "✌️"}
        amount={`£${Number(
            payment?.amount
        ).toFixed(2)}`}
        isPaymentProcessing={Boolean(paymentStatus === "PENDING")}
        isLoading={false}
        logTitle={logTitle}
        status={paymentStatus}
    />
}
